import {
  getList,
  getObject,
  getInt32,
  getBoolean,
  getOptionalBoolean,
} from "@surya-digital/leo-ts-types";
import { OptionV1, OptionV1DTO } from "./optionV1";


export namespace RankingQuestionV1Enums {
  export namespace MandatoryCheck {
    export interface AllOptionsMandatoryDTO {
      case: string;
    }
    
    export class AllOptionsMandatory {
      readonly isMandatoryCheckAllOptionsMandatory: boolean = true;
    
    
    
    
    
      toDTO(): AllOptionsMandatoryDTO {
        const dto: AllOptionsMandatoryDTO = {
          case: "ALL_OPTIONS_MANDATORY",
        };
        return dto;
      }
      }
    
    AllOptionsMandatory.prototype.toString = function toString(): string {
      return `MandatoryCheck.ALL_OPTIONS_MANDATORY()`;
    };
    
    export interface AllOptionsNotMandatoryDTO {
      case: string;
      maxSelectionAllowed: number;
    }
    
    export class AllOptionsNotMandatory {
      readonly isMandatoryCheckAllOptionsNotMandatory: boolean = true;
    
      readonly maxSelectionAllowed: number;
    
      static readonly constraints = {
        "maxSelectionAllowed": {
          "minValue": 1,
          "maxValue": 32,
        }
      }
    
      constructor(
      maxSelectionAllowed: number
      ) {
        AllOptionsNotMandatory.validateMaxSelectionAllowed(maxSelectionAllowed);
        this.maxSelectionAllowed = maxSelectionAllowed;
      }
    
      static fromDTO(dto: AllOptionsNotMandatoryDTO): AllOptionsNotMandatory {
        const maxSelectionAllowed = getInt32(dto, "maxSelectionAllowed", InvalidRankingQuestionV1MandatoryCheckAllOptionsNotMandatoryMaxSelectionAllowedError);
        return new AllOptionsNotMandatory(
          maxSelectionAllowed
        );
      }
    
      toDTO(): AllOptionsNotMandatoryDTO {
        const dto: AllOptionsNotMandatoryDTO = {
          case: "ALL_OPTIONS_NOT_MANDATORY",
            maxSelectionAllowed: this.maxSelectionAllowed
        };
        return dto;
      }
      private static validateMaxSelectionAllowed = (maxSelectionAllowed: number): void => {
        if(maxSelectionAllowed < 1) {
          throw new InvalidRankingQuestionV1MandatoryCheckAllOptionsNotMandatoryMaxSelectionAllowedMinValueError(
            1,
            `Attribute maxSelectionAllowed has value ${maxSelectionAllowed}. Min value is 1.`
          );
        }
        if(maxSelectionAllowed > 32) {
          throw new InvalidRankingQuestionV1MandatoryCheckAllOptionsNotMandatoryMaxSelectionAllowedMaxValueError(
            32,
            `Attribute maxSelectionAllowed has value ${maxSelectionAllowed}. Max value is 32.`
          );
        }
      }
      
    }
    
    AllOptionsNotMandatory.prototype.toString = function toString(): string {
      return `MandatoryCheck.ALL_OPTIONS_NOT_MANDATORY(maxSelectionAllowed='${this.maxSelectionAllowed}')`;
    };
    
  
    export type MandatoryCheck = AllOptionsMandatory | AllOptionsNotMandatory;
  
    export type MandatoryCheckDTO = AllOptionsMandatoryDTO | AllOptionsNotMandatoryDTO;
  
    export const fromDTO = (dto: MandatoryCheckDTO): MandatoryCheck => {
      switch (dto.case) {
        case "ALL_OPTIONS_MANDATORY":
            return new AllOptionsMandatory();
        case "ALL_OPTIONS_NOT_MANDATORY":
            return AllOptionsNotMandatory.fromDTO(dto as AllOptionsNotMandatoryDTO);
        default:
          throw new InvalidRankingQuestionV1MandatoryCheckError(
              `Case ${dto.case} is not valid case of MandatoryCheck.`
          );
      }
    };
  }
  
}
export interface RankingQuestionV1DTO {
  options: OptionV1DTO[];
  mandatoryCheck: RankingQuestionV1Enums.MandatoryCheck.MandatoryCheckDTO;
  isUnanswered?: boolean | null;
}

export class RankingQuestionV1 {
  readonly isRankingQuestionV1RankingQuestionV1: boolean = true;

  readonly options: OptionV1[];
  readonly mandatoryCheck: RankingQuestionV1Enums.MandatoryCheck.MandatoryCheck;
  readonly isUnanswered: boolean | null;

  static readonly constraints = {
    "options": {
      "minSize": 1,
      "maxSize": 32,
    },
  }

  constructor(
  options: OptionV1[], 
  mandatoryCheck: RankingQuestionV1Enums.MandatoryCheck.MandatoryCheck, 
  isUnanswered: boolean | null = null
  ) {
    RankingQuestionV1.validateOptions(options);
    this.options = options;
    this.mandatoryCheck = mandatoryCheck;
    this.isUnanswered = isUnanswered;
  }

  static fromDTO(dto: RankingQuestionV1DTO): RankingQuestionV1 {
    const options = getList<OptionV1DTO, OptionV1>(
      dto,
      "options",
      OptionV1.fromDTO,
      InvalidRankingQuestionV1OptionsError
    );
    const mandatoryCheck = RankingQuestionV1Enums.MandatoryCheck.fromDTO(getObject(dto, "mandatoryCheck", InvalidRankingQuestionV1MandatoryCheckError));
    const isUnanswered = getOptionalBoolean(dto, "isUnanswered", InvalidRankingQuestionV1IsUnansweredError);
    return new RankingQuestionV1(
      options,
      mandatoryCheck,
      isUnanswered
    );
  }

  toDTO(): RankingQuestionV1DTO {
    const dto: RankingQuestionV1DTO = {
        options: this.options.map((e: OptionV1) => { return e.toDTO() }),
        mandatoryCheck: this.mandatoryCheck.toDTO(),
    };
    if (this.isUnanswered !== undefined && this.isUnanswered !== null){
      dto.isUnanswered = this.isUnanswered;
    }
    return dto;
  }
  private static validateOptions = (options: OptionV1[]): void => {
    if(options.length < 1) {
      throw new InvalidRankingQuestionV1OptionsMinSizeError(
        1,
        `Attribute options is too short. Size is ${options.length}. Min size is 1.`
      );
    }
    if(options.length > 32) {
      throw new InvalidRankingQuestionV1OptionsMaxSizeError(
        32,
        `Attribute options is too long. Size is ${options.length}. Max size is 32.`
      );
    }
  }
  
}

RankingQuestionV1.prototype.toString = function toString(): string {
  return `RankingQuestionV1(options='${this.options}',mandatoryCheck='${this.mandatoryCheck}',isUnanswered='${this.isUnanswered}')`;
};

export class InvalidRankingQuestionV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingQuestionV1Error";
  }
}
export class InvalidRankingQuestionV1OptionsError extends InvalidRankingQuestionV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingQuestionV1OptionsError";
  }
}

export class InvalidRankingQuestionV1OptionsMaxSizeError extends InvalidRankingQuestionV1OptionsError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingQuestionV1OptionsMaxSizeError";
  }
}

export class InvalidRankingQuestionV1OptionsMinSizeError extends InvalidRankingQuestionV1OptionsError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingQuestionV1OptionsMinSizeError";
  }
}

export class InvalidRankingQuestionV1MandatoryCheckError extends InvalidRankingQuestionV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingQuestionV1MandatoryCheckError";
  }
}

export class InvalidRankingQuestionV1MandatoryCheckAllOptionsMandatoryError extends InvalidRankingQuestionV1MandatoryCheckError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingQuestionV1MandatoryCheckAllOptionsMandatoryError";
  }
}

export class InvalidRankingQuestionV1MandatoryCheckAllOptionsNotMandatoryError extends InvalidRankingQuestionV1MandatoryCheckError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingQuestionV1MandatoryCheckAllOptionsNotMandatoryError";
  }
}

export class InvalidRankingQuestionV1MandatoryCheckAllOptionsNotMandatoryMaxSelectionAllowedError extends InvalidRankingQuestionV1MandatoryCheckAllOptionsNotMandatoryError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingQuestionV1MandatoryCheckAllOptionsNotMandatoryMaxSelectionAllowedError";
  }
}

export class InvalidRankingQuestionV1MandatoryCheckAllOptionsNotMandatoryMaxSelectionAllowedMaxValueError extends InvalidRankingQuestionV1MandatoryCheckAllOptionsNotMandatoryMaxSelectionAllowedError {
  readonly maxValue: number;
  constructor(maxValue: number, message?: string) {
    super(message);
    this.maxValue = maxValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingQuestionV1MandatoryCheckAllOptionsNotMandatoryMaxSelectionAllowedMaxValueError";
  }
}

export class InvalidRankingQuestionV1MandatoryCheckAllOptionsNotMandatoryMaxSelectionAllowedMinValueError extends InvalidRankingQuestionV1MandatoryCheckAllOptionsNotMandatoryMaxSelectionAllowedError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingQuestionV1MandatoryCheckAllOptionsNotMandatoryMaxSelectionAllowedMinValueError";
  }
}

export class InvalidRankingQuestionV1IsUnansweredError extends InvalidRankingQuestionV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingQuestionV1IsUnansweredError";
  }
}
